/*
  Kiwi Ears · award-card slider (Rene 2026-08-23).

  A product can win more than one award, so the award row at the bottom of an
  award card is a horizontal scroll-snap track. The track needs NO JS to work
  — it swipes and scrolls natively. This script only adds what scroll-snap
  cannot: dots, one per slide, that show where you are and jump on click.

  Deliberately no autoplay. An auto-advancing strip inside a card is exactly
  the kind of unrequested motion reduced-motion users turn off, and a jury
  citation is not something to rotate away from mid-read.
*/
(function () {
  if (window.__kiwiAwardsReady) return;
  window.__kiwiAwardsReady = true;

  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function arm() {
    [].slice.call(document.querySelectorAll('[data-awslider]')).forEach(function (root) {
      var track = root.querySelector('[data-awtrack]');
      if (!track) return;
      var slides = [].slice.call(track.children);
      if (slides.length < 2) return;

      var dots = document.createElement('div');
      dots.className = 'ab-awdots';
      slides.forEach(function (_, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'ab-awdot';
        d.setAttribute('aria-label', 'Award ' + (i + 1) + ' of ' + slides.length);
        if (i === 0) d.setAttribute('aria-current', 'true');
        d.addEventListener('click', function () {
          track.scrollTo({ left: i * track.clientWidth, behavior: still ? 'auto' : 'smooth' });
        });
        dots.appendChild(d);
      });
      root.appendChild(dots);

      var kids = [].slice.call(dots.children);
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        kids.forEach(function (d, n) {
          if (n === i) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
      }, { passive: true });
    });
  }

  /* -------- archive filters (sections/aw-archive, Rene 2026-08-31) --------
     Year and program chips DERIVED from the rows' data attributes — a chip
     that filters nothing is never offered (the fnd-facets discipline). The
     rows are server-rendered; this only hides the ones filtered out. */
  function armArchive() {
    var root = document.querySelector('[data-aw-archive]');
    if (!root) return;
    var rows = [].slice.call(root.querySelectorAll('[data-aw-row]'));
    var empty = root.querySelector('[data-aw-empty]');
    if (!rows.length) return;
    var state = { year: '', program: '' };

    function buildChips(wrap, attr, key) {
      if (!wrap) return;
      var seen = [];
      rows.forEach(function (r) {
        var v = r.getAttribute(attr);
        if (v && seen.indexOf(v) === -1) seen.push(v);
      });
      if (seen.length < 2) return; /* one value filters nothing */
      if (attr === 'data-year') seen.sort().reverse();
      var mk = function (label, value) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cmp-chip';
        b.setAttribute('data-aw-filter', key);
        b.setAttribute('data-value', value);
        b.setAttribute('aria-pressed', String(value === ''));
        b.textContent = label;
        return b;
      };
      wrap.appendChild(mk(wrap.getAttribute('data-all-label') || 'All', ''));
      seen.forEach(function (v) { wrap.appendChild(mk(v, v)); });
    }
    buildChips(root.querySelector('[data-aw-years]'), 'data-year', 'year');
    buildChips(root.querySelector('[data-aw-programs]'), 'data-program', 'program');

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-aw-filter]');
      if (!b) return;
      var key = b.getAttribute('data-aw-filter');
      state[key] = b.getAttribute('data-value');
      [].slice.call(root.querySelectorAll('[data-aw-filter="' + key + '"]')).forEach(function (x) {
        x.setAttribute('aria-pressed', String(x === b));
      });
      var shown = 0;
      rows.forEach(function (r) {
        var ok = (!state.year || r.getAttribute('data-year') === state.year) &&
                 (!state.program || r.getAttribute('data-program') === state.program);
        r.hidden = !ok;
        if (ok) shown++;
      });
      if (empty) empty.classList.toggle('hidden', shown > 0);
    });
  }

  if (document.readyState === 'complete') { arm(); armArchive(); }
  else window.addEventListener('load', function () { arm(); armArchive(); });
})();
